module.exports = __webpack_public_path__ + "img/title-four.d7a7e14d.png";